export default __webpack_public_path__ + "static/media/mail.bcda7c23.png";